import React from "react";
import createSvgIcon from "../../witadmin/icons/createSvgIcon";

export default createSvgIcon(
  <g>
    <path d="M14.0589 1.36853L1 14.4274" stroke="white" strokeWidth="2.74924" />
    <path d="M0.999999 1.36849L14.0589 14.4274" stroke="white" strokeWidth="2.74924" />
  </g>,
  "Close"
);
